import "bootstrap";

import "jquery.easing"
import "magnific-popup"
import "jquery-match-height"
import "scroll-hint"
import "magnific-popup"

import "./modules/aos";
import "./modules/swiper";

import "./modules/base/common"
import "./modules/base/block_parts"
// import "./modules/base/block_custom"


import "./modules/navbar"
import "./modules/animation"
import "./modules/collapse"
import "./modules/chart"

